import vipGold from "../../assets/imgs/vip/gold.png";
import vipSilver from "../../assets/imgs/vip/silver.png";
import vipBronze from "../../assets/imgs/vip/bronze.png";

function formatVipEndDate(value) {
  if (value == null || value === "") {
    return "—";
  }
  const raw = String(value);
  const dateOnly = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (dateOnly) {
    return dateOnly[1];
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return raw;
  }
  const y = parsed.getUTCFullYear();
  const m = String(parsed.getUTCMonth() + 1).padStart(2, "0");
  const d = String(parsed.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export const CheckVip = (vipType, VIP_FULLDATE) => {
  const vipEnd = formatVipEndDate(VIP_FULLDATE);

  switch (vipType) {
    case 0:
      return "N/A";
    case 1:
      return (
        <span
          style={{
            color: "#E3AF66",
            textShadow: "0px 2px 7px rgb(135 122 51 / 38%)",
          }}
        >
          Bronze&nbsp;
          <span
            style={{
              position: "relative",
            }}
          >
            <img
              style={{
                position: "absolute",
                bottom: "-2px",
                left: "-5px",
              }}
              src={vipBronze}
              alt=""
              width="25"
              height="25"
            />
          </span>
          <br />
          <span style={{ color: "white" }}>
            Vip-End:&nbsp;
            <span style={{ color: "#E3AF66" }}>{vipEnd}</span>
          </span>
        </span>
      );
    case 2:
      return (
        <span
          style={{
            color: "lightgray",
            textShadow: "0px 2px 7px rgb(135 122 51 / 38%)",
          }}
        >
          Silver&nbsp;
          <span
            style={{
              position: "relative",
            }}
          >
            <img
              style={{
                position: "absolute",
                bottom: "-2px",
                left: "-2px",
              }}
              src={vipSilver}
              alt=""
              width="25"
              height="25"
            />
          </span>
          <br />
          <span style={{ color: "white" }}>
            Vip-End: &nbsp;
            <span style={{ color: "lightgray" }}>{vipEnd}</span>
          </span>
        </span>
      );
    case 3:
      return (
        <span
          style={{
            color: "gold",
            textShadow: "0px 2px 7px rgb(135 122 51 / 38%)",
            position: "relative",
          }}
        >
          Gold &nbsp;
          <span
            style={{
              position: "relative",
            }}
          >
            <img
              style={{
                position: "absolute",
                bottom: "-2px",
                left: "-2px",
              }}
              src={vipGold}
              alt=""
              width="25"
              height="25"
            />
          </span>
          <br />
          <span style={{ color: "white" }}>
            Vip-End: &nbsp;
            <span style={{ color: "gold" }}>{vipEnd}</span>
          </span>
        </span>
      );
    default:
      return "N/A";
  }
};
